import React, { useState } from 'react';
import {
  Container,
  FormControl,
  TextField,
  Button,
  Paper,
  Typography,
  Alert,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Loader from '../components/other/Loader';
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha,
} from 'react-google-recaptcha-v3';

import { getAuth, signInWithPopup, GoogleAuthProvider, onAuthStateChanged, signOut } from 'firebase/auth';
import { NavLink } from 'react-router-dom';
import axios from 'axios';

const useStyles = makeStyles()(() => ({
  root: {
    padding: '40px 20px',
    maxWidth: '700px',
    margin: 'auto',
  },
  textField: {
    marginBottom: '15px',
  },
  submitButton: {
    marginTop: '20px',
  },
}));

const Contact = () => {
  const { classes } = useStyles();
  const auth = getAuth();

  const [values, setValues] = useState({});
  const [{ Loading, finished, error, timeoutTimer }, setForm] = useState({
    Loading: false,
    finished: false,
    error: false,
    timeoutTimer: null,
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleVerify = (token) => {
    setValues({
      ...values,
      token: token,
    });
  };

  const handleTimeout = () => {
    if (!finished) {
      setForm({ Loading: false, finished: false, error: true, timeoutTimer: null });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const timeout = setTimeout(handleTimeout, 30000);
    setForm({ Loading: true, finished: false, error: false, timeoutTimer: timeout });

    const currentUser = auth.currentUser;
    if (currentUser) {
      currentUser
        .getIdToken()
        .then((idToken) => {
          handleForm(idToken);
        })
        .catch(() => {
          clearTimeout(timeout);
          setForm({ Loading: false, finished: false, error: true, timeoutTimer: null });
        });
    } else {
      handleForm(null);
    }
  };

  const handleForm = (idToken) => {
    const messageData = {
      service: 'iot',
      name: values.name || '',
      email: values.email || '',
      message: values.message || '',
      token: values.token || '',
      userIdToken: idToken || '',
    };

    const headers = idToken ? { headers: { Authorization: idToken } } : {};

    axios
      .post('https://api.spried.com/contact', messageData, headers)
      .then((result) => {
        clearTimeout(timeoutTimer);
        setForm({ Loading: false, finished: true, error: false, timeoutTimer: null });
      })
      .catch((err) => {
        clearTimeout(timeoutTimer);
        setForm({ Loading: false, finished: false, error: true, timeoutTimer: null });
      });
  };

  if (Loading) {
    return (
      <main className={classes.root}>
        <Typography variant="h4" gutterBottom>
          Contact / Ideas
        </Typography>
        <Loader />
      </main>
    );
  }

  if (finished) {
    return (
      <main className={classes.root}>
        <Typography variant="h4" gutterBottom>
          Contact / Ideas
        </Typography>
        <Alert severity="success">Thank you! Your message has been received.</Alert>
        <Button
          component={NavLink}
          to="/"
          variant="contained"
          color="primary"
          className={classes.submitButton}
        >
          Go Home
        </Button>
      </main>
    );
  }

  if (error) {
    return (
      <main className={classes.root}>
        <Typography variant="h4" gutterBottom>
          Contact / Ideas
        </Typography>
        <Alert severity="error">Something went wrong. Please try again later.</Alert>
      </main>
    );
  }

  return (
    <main className={classes.root}>
      <Typography variant="h4" gutterBottom>
        Contact / Ideas
      </Typography>
      <Typography variant="body1" gutterBottom>
        Please contact us any time about anything.
      </Typography>

      <GoogleReCaptchaProvider reCaptchaKey="6Ldt0FkdAAAAAJ7wk1tteGK4IxMlTS9CXJhUD3DT">
        <form onSubmit={handleSubmit}>
          <TextField
            required
            name="name"
            label="Name"
            variant="outlined"
            fullWidth
            onChange={handleChange}
            className={classes.textField}
          />
          <TextField
            required
            name="email"
            label="Email"
            type="email"
            variant="outlined"
            fullWidth
            onChange={handleChange}
            className={classes.textField}
          />
          <TextField
            required
            name="message"
            label="Message"
            multiline
            rows={6}
            variant="outlined"
            fullWidth
            onChange={handleChange}
            className={classes.textField}
          />
          {values && !values.token && (
            <GoogleReCaptcha onVerify={handleVerify} />
          )}
          <Button
            type="submit"
            color="primary"
            variant="contained"
            fullWidth
            className={classes.submitButton}
          >
            Submit
          </Button>
        </form>
      </GoogleReCaptchaProvider>
    </main>
  );
};

export default Contact;
